import { useState, VFC } from 'react'
import { withLoginUser } from 'src/api/user'
import {
  usePremiumContributionsSearch,
  PremiumContributionSearchParams,
  PremiumContibutionsSearchData,
} from 'src/api/premiumContribution'
import { MemberHeader } from 'src/components/Header'
import { PremiumContributionLayout } from './PremiumContributionLayout'
import { Loading } from '../../components/Loading'
import { BASE_PATH, premiumContributionDetail } from 'src/utils/routes'

export const PremiumContributions: VFC = withLoginUser(({ user }) => {
  const [searchParams, setSearchParams] =
    useState<PremiumContributionSearchParams>({
      keyword: '',
      contentTag: '',
      status: '',
      entryStatus: '',
      page: 1,
    })

  const { data, isValidating } = usePremiumContributionsSearch(searchParams)

  if (isValidating || !data) return <Loading isLoading={true} />

  const { premiumContributions, totalCount, onePageDisplayItems } =
    data as PremiumContibutionsSearchData

  // ページ変更時の処理
  const handlePageChange = (newPage: number) => {
    setSearchParams((prev) => ({
      ...prev,
      page: newPage,
    }))
  }

  return (
    <>
      <MemberHeader
        user={user}
        currentPath="プレミアム55投稿"
        displayBreadCrumb={false}
      />
      <PremiumContributionLayout
        user={user}
        premiumContributions={premiumContributions}
        currentPage={searchParams.page || 1}
        totalCount={totalCount}
        onePageDisplayItems={onePageDisplayItems}
        keyword={searchParams.keyword || ''}
        contentTag={searchParams.contentTag || ''}
        status={searchParams.status || ''}
        entryStatus={searchParams.entryStatus || ''}
        showProfile={(id: number) =>
          window.open(BASE_PATH + premiumContributionDetail(id), '_blank')
        }
        setPage={handlePageChange}
        onSearch={(newSearchParams) =>
          setSearchParams((prev) => ({
            ...prev,
            ...newSearchParams,
            page: 1,
          }))
        }
      />
    </>
  )
})
